<i18n>
{
  "en": {
    "title": "Generate password token",
    "yourRegistEmail": "Your registered e-mail address",
    "sendEmail": "send email",
    "confMessage": "If the email is registered you will get an email shortly. you gone a be redirected in 10 seconds."
  },
  "fr": {
    "title": "Recevoir un jeton pour un nouveau mot de passe",
    "yourRegistEmail": "Votre adresse mail",
    "sendEmail": "envoyer l'e-mail",
    "confMessage": "Si l'adresse e-mail rensegner est bonne vous devriais recevoir un e-mail rappidement. Vous allez ètre redirigé dans 10 secondes."
  }
}
</i18n>

<template>
  <div>
    <h1 class="mdc-typography--headline3">{{ $t('title') }}</h1>
    <div class="mdc-text-field" style="width: 100%;" @keydown.enter="submit">
      <input id="reset" class="mdc-text-field__input" type="text" v-model="email">
      <label class="mdc-floating-label" for="reset">{{ $t('yourRegistEmail') }}</label>
      <div class="mdc-line-ripple"></div>
    </div>
    <button class="mdc-button mdc-button--outlined" style="margin: 1em" @click="submit">
      <i class="material-icons mdc-button__icon" aria-hidden="true">backup</i>
      <span class="mdc-button__label">{{ $t('sendEmail') }}</span>
    </button>

    <div class="mdc-snackbar">
      <div class="mdc-snackbar__surface">
        <div class="mdc-snackbar__label" role="status" aria-live="polite">{{ $t('confMessage') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';
import { MDCSnackbar } from '@material/snackbar';

import Axios from 'axios';

export default {
  data() {
    return {
      email: '',
      snackbar: null,
    };
  },
  methods: {
    submit() {
      const vue = this;
      Axios.post('/API/sendForgotPasswordLink', { Email: this.email }).then((result) => {
        vue.snackbar.open();
        setTimeout(() => {
          vue.$router.push('/');
        }, 10 * 1000); // redirect to root in 10 seconds
      }).catch((err) => {
        console.warn(err);
      });
    },
  },
  mounted() {
    const textField = new MDCTextField(document.querySelector('.mdc-text-field'));

    const ripple = new MDCRipple(document.querySelector('.mdc-button'));
    this.snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
    return new MDCTextField(document.querySelector('.mdc-text-field'));
  },
  destroyed() {
    this.snackbar.destroy();
  },
};
</script>
